export default "__VITE_PUBLIC_ASSET__018698dc__"